import Header from "@Components/Header/Header";
import Footer from "@Components/Footer/Footer";
import Breadcrumb from "@Components/DetailsPageBanner/components/Breadcrumb";
import { AppRouteURL, AppRouteURLwithChilds } from "@Constants/app-route-url.constant";
import { MobHeader } from "@Components/Mob-header/Mob-header";
import "./TermsAndConditions.scss";

export const TermsAndConditions = () => {
  const Headings = [{ name: "Terms & Conditions", type: "TERMS" }];

  return (
    <>
      <Header />
      <MobHeader />
      <section className="mock-test-listining-container">
        <div className="ia-container">
          <div className="grid">
            <div className="col-12 py-2">
              <div className="pt-4">
                <Breadcrumb Headings={Headings} />
              </div>
              <div className="m-t-l-header text-white pt-3 ml-0">
                <span>Terms & Conditions</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="about-us py-2 lg:py-6">
        <div className="ia-container pt-3">
          <div className="tw-space-y-4">
            <h2 className="tw-text-2xl tw-font-semibold tw-mt-6 tw-mb-4">1. Acceptance of Terms</h2>
            <p>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. By accessing and using this platform, you agree to be bound by these terms and conditions. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.
            </p>

            <h2 className="tw-text-2xl tw-font-semibold tw-mt-6 tw-mb-4">2. User Accounts & Responsibilities</h2>
            <p>
              Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris. Users must not engage in any illegal activities while using the platform. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore.
            </p>
            <p>
              Excepteur sint occaecat cupidatat non proident. You are responsible for maintaining the security of your account credentials and all activities under your account.
            </p>

            <h2 className="tw-text-2xl tw-font-semibold tw-mt-6 tw-mb-4">3. Privacy & Data Usage</h2>
            <p>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. We collect personal information including name, email, and usage data. Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas.
            </p>
            <p>
              Vestibulum tortor quam, feugiat vitae, ultricies eget. Your data is used to provide services, improve user experience, and communicate important updates. Tempor sit amet, ante donec eu libero sit amet quam egestas semper.
            </p>

            <h2 className="tw-text-2xl tw-font-semibold tw-mt-6 tw-mb-4">4. Payments & Transactions</h2>
            <p>
              Aenean ultricies mi vitae est mauris placerat eleifend leo. All fees and charges are clearly displayed before purchase. Quisque sit amet est et sapien ullamcorper pharetra vestibulum erat wisi.
            </p>
            <p>
              Condimentum sed, commodo vitae, ornare sit amet. Refunds are processed according to our refund policy within 7-14 business days. Aliquam convallis sollicitudin purus praesent aliquam.
            </p>

            <h2 className="tw-text-2xl tw-font-semibold tw-mt-6 tw-mb-4">5. Limitation of Liability</h2>
            <p>
              Enim at fermentum mollis, ligula massa adipiscing nisl. The platform is not responsible for any indirect, incidental, or consequential damages arising from use of services. Ac euismod nibh nisl eu lectus fusce vulputate sem at sapien.
            </p>

            <h2 className="tw-text-2xl tw-font-semibold tw-mt-6 tw-mb-4">6. Intellectual Property</h2>
            <p>
              Vivamus leo aliquam euismod libero eu enim. All content, trademarks, and materials on this platform are owned by us or our licensors. Aenean fermentum elit eget tincidunt condimentum eros ipsum rutrum orci.
            </p>
            <p>
              Sagittis tempus lacus enim ac dui. Users retain ownership of content they create but grant us license to use it for platform operations.
            </p>

            <h2 className="tw-text-2xl tw-font-semibold tw-mt-6 tw-mb-4">7. Termination</h2>
            <p>
              Donec non enim in turpis pulvinar facilisis ut felis. We reserve the right to suspend or terminate user accounts for violation of terms, illegal activities, or misuse of platform. Praesent dapibus neque id cursus faucibus.
            </p>

            <h2 className="tw-text-2xl tw-font-semibold tw-mt-6 tw-mb-4">8. Governing Law</h2>
            <p>
              Tortor neque egestas augue eu vulputate magna eros eu erat. These terms and conditions are governed by the laws of India. Aliquam convallis sollicitudin purus praesent aliquam enim at fermentum mollis ligula massa adipiscing nisl.
            </p>
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
};
